var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDisabledSortableAnchorTableOrderDescAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1216-384h1280v800h-1280z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d9d9d9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m288 216h-32v-4h28v-28h4z",
    transform: "matrix(.522955 .522955 -.525161 .525161 -5.21 -210.552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 216h-32v-4h28v-28h4z",
    transform: "matrix(-.522955 -.522955 .525161 -.525161 69.21 274.552)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDisabledSortableAnchorTableOrderDescAsc);
export default __webpack_public_path__ + "static/media/sort-disabled-sortable-anchor-table-order-desc-asc.93e187afa8dfbabf87851e73ecf2a800.svg";
export { ForwardRef as ReactComponent };